import React, { useState, useLayoutEffect } from 'react';
import { useDispatch } from 'react-redux';
import ReactHtmlParser from 'react-html-parser';
import { combineClassNames, reactParserCommonOptions } from '../../../../app/functions';
import { setTravelInsurancePopupAgreement, updateUserData } from '../../../../redux/actions';
import Loader from '../../../../components/common/loader';
import Checkbox from '../../../../components/forms/checkbox';
import closeIconPath from '../../../../assets/icons/login-x-icon.svg';
import checkedCheckboxImagePath from '../../../../assets/icons/cb_checked.svg';
import emptyCheckboxImagePath from '../../../../assets/icons/cb_empty.svg';
import './index.scss';

const TravelInsurancePopup = ({ data, onAgreement, handleClose }) => {
    const dispatch = useDispatch();

    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const [isProcessing, setIsProcessing] = useState(false);
    const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);
    const [checkboxError, setCheckboxError] = useState(null);

    const openPopup = () => setIsPopupVisible(true);

    const closePopup = () => {
        // Prevent closing the popup while waiting for a response
        if (isProcessing) return;

        setIsPopupVisible(false);
        setTimeout(handleClose, 250);
    };
    
    const handleBackdropClick = ({ target }) => {
        // Close popup only if backdrop was clicked, not its children
        if (target.classList.contains('backdrop')) {
            closePopup();
        }
    };

    const toggleCheckboxError = (showError) => {
        if (showError) {
            setCheckboxError(data?.error_message);
        } else {
            setCheckboxError(null);
        }
    };

    const handleCheckboxChange = () => {
        const newValue = !isCheckboxChecked;

        setIsCheckboxChecked(newValue);
        toggleCheckboxError(!newValue);
    }

    const handleSubmitButtonClick = () => {
        if (!isCheckboxChecked) {
            toggleCheckboxError(true);
            return;
        }

        setIsProcessing(true);

        dispatch(setTravelInsurancePopupAgreement(() => {
            dispatch(updateUserData({
                hasAgreedToTravelPopup: true,
            }));

            onAgreement();
            handleClose();
            setIsProcessing(false);
        }));
    };

    useLayoutEffect(openPopup, []);

    return (
        <div
            className={combineClassNames(
                'backdrop',
                isPopupVisible && 'active',
            )}
            onClick={handleBackdropClick}
        >
            <div className="travel-insurance-popup">
                <button
                    type="button"
                    className="popup-close-button"
                    onClick={closePopup}
                    aria-label="Close Popup"
                >
                    <img src={closeIconPath} alt="Close Icon" />
                </button>

                <div className="popup-content">
                    {isProcessing ? (
                        <div className="popup-loader-container">
                            <Loader className="popup-loader" />
                        </div>
                    ) : (
                        <>
                            <h2 className="popup-title">
                                {data?.title}
                            </h2>

                            <div className="popup-main-content">
                                {ReactHtmlParser(data?.content, reactParserCommonOptions())}
                            </div>

                            <div className="popup-checkbox">
                                <Checkbox
                                    name="travel-insurance-checkbox"
                                    label={data?.checkbox_content}
                                    onChange={handleCheckboxChange}
                                    checked_img={checkedCheckboxImagePath}
                                    not_checked_img={emptyCheckboxImagePath}
                                    showError={Boolean(checkboxError)}
                                    errorMessage={checkboxError}
                                    className="popup-checkbox-element"
                                />
                            </div>

                            <button
                                type="button"
                                className="popup-submit-button"
                                onClick={handleSubmitButtonClick}
                            >
                                {data?.submit_button}
                            </button>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default TravelInsurancePopup;
